export default "__VITE_ASSET__b326d505__$_?react__"